import ActionTypes from './ActionTypes';
import InteractionTypes from './InteractionTypes';

const FeatureType = 'Series Read-alikes';

const SimilarSeriesEventTypes = {
	SIMILARSERIES_NOVELIST_CLICKED: { 
        featureClick: { 
            name: "SimilarSeriesPLink" 
        },
        interaction: {
            name: 'Similar Series: NoveList - clicked',
            actionType: ActionTypes.P_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
	SIMILARSERIES_LISTCOVER_CLICKED: { 
        featureClick: { 
            name: "SimilarSeriesReasoning" 
        },
        interaction: {
            name: 'Similar Series: List Cover - clicked',
            actionType: ActionTypes.INLINE_DISPLAY,
            interactionType: InteractionTypes.UX_ACTION,
            featureType: FeatureType
        }
    },
    SIMILARSERIES_DETAILVIEWCOVER_CLICKED: {
        featureClick: { 
            name: "SimilarSeriesTitleInfo" 
        },
        interaction: {
            name: 'Similar Series: Detail View Cover - clicked',
            actionType: ActionTypes.CATALOG_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
    SIMILARSERIES_DETAILVIEWNAME_CLICKED: {
        featureClick: { 
            name: "SimilarSeriesTitleInfo" 
        },
        interaction: {
            name: 'Similar Series: Detail View Name - clicked',
            actionType: ActionTypes.CATALOG_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        }
    },
    SIMILARSERIES_AVAILABILITY_CLICKED: {
        featureClick: { 
            name: "Ots" 
        },
        interaction: {
            name: 'Similar Series: Availability - clicked',
            actionType: ActionTypes.INLINE_DISPLAY,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        } 
    },
    SIMILARSERIES_FINDIT_CLICKED: {
        featureClick: { 
            name: "SimilarSeriesTitleInfo" 
        },
        interaction: {
            name: 'Similar Series: Find It - clicked',
            actionType: ActionTypes.CATALOG_LINK,
            interactionType: InteractionTypes.CALL_TO_ACTION,
            featureType: FeatureType
        } 
    }
}

export default SimilarSeriesEventTypes;


// WEBPACK FOOTER //
// ./src/data/types/SimilarSeriesEventTypes.js